import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";

import { Button, FormGroup, Row } from "reactstrap";
import axios from "axios";

import Config_local from "./../../../../config/Config_local";

import InputField from "./components/InputField";
import RadioField from "./components/RadioField";
import SelectField from "./components/SelectField";
import DateField from "./components/DateField";
import CheckField from "./components/CheckField";
import ConsentField from "./components/ConsentField";
import UploadField from "./components/UploadField";
import SectionField from "./components/SectionField";
import AddressField from "./components/AddressField";

const axiosConfig = {
  method: "post",
  responseType: "json",
  responseEncoding: "utf8",
  mode: "no-cors",
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

const switchField = {
  text: rest => <InputField {...rest} />,
  name: rest => <InputField {...rest} />,
  email: rest => <InputField {...rest} />,
  tel: rest => <InputField {...rest} />,
  checkbox: rest => <CheckField {...rest} />,
  consent: rest => <ConsentField {...rest} />,
  radio: rest => <RadioField {...rest} />,
  select: rest => <SelectField {...rest} />,
  date: rest => <DateField {...rest} />,
  fileupload: rest => <UploadField {...rest} />,
  textarea: rest => <InputField {...rest} />,
  section: rest => <SectionField {...rest} />,
  address: rest => <AddressField {...rest} />
};

const switchSize = {
  small: "col-12 col-md-3",
  medium: "col-12 col-md-6",
  large: "col-12"
};

class CustomForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
			validCaptcha : false,
			valueCaptcha : null,
      submitted: false,
      error: false,
      loading: false
    };
  }

  validSubmit = (event, values) => {
    if ( this.state.validCaptcha ) {
      this.setState({
        loading: true,
        submitted: true
      });
      const formData = new FormData();
      const arrayValues = Object.keys(values).map(function(key) {
        return [key, values[key]];
      });

      arrayValues.map(keyValue => {
        const index = keyValue[0],
          value = keyValue[1];
        if (Array.isArray(value))
          value.map(valueString => {
            const valueObject = JSON.parse(valueString);
            formData.append(valueObject.fieldId, valueObject.value);
            return null;
          });
        else formData.append(index, value);
        return null;
      });

      const self = this;
      const postConfig = {
        ...axiosConfig,
        ...{
          data: formData,
          url: Config_local.apiServer + this.props.attrs.form_url + "/submissions"
        }
      };
      axios(postConfig)
        .then(({ data }) => {
          if (data.is_valid) self.setState({ error: false, loading: false });
          else throw new Error("error");
        })
        .catch(() => {
          self.setState({ error: true, loading: false });
        });
    }
  }

  invalidSubmit = (event, errors, values) => {
    this.setState({ error: true, submitted: false, loading: false });
  }

  resetForm = () => {
    this.setState({ error: false, submitted: false, loading: false });
  }

	onCaptchaChange = (value) => {
		if ( value !== null ) {
      this.setState({ validCaptcha: true, valueCaptcha: value})
    } else { 
      this.setState({ validCaptcha: false})
    }
	}

  render() {
    const { attrs } = this.props;
    const { submitted, error, loading, valueCaptcha } = this.state;

    // Validation des props
    if (!attrs || !attrs.wordpress_fields || !Array.isArray(attrs.wordpress_fields)) {
      return (
        <div role="alert" aria-live="polite" className="form-error">
          Configuration du formulaire invalide
        </div>
      );
    }

    if (submitted && !error && !loading) {
      return (
        <section 
          className="form-container submitted valid"
          role="region"
          aria-label="Confirmation du formulaire"
          aria-live="polite"
        >
          <h2 className="visually-hidden">Confirmation</h2>
          <p>
            {attrs.defaultConfirmation && attrs.defaultConfirmation.message
              ? attrs.defaultConfirmation.message
              : "Le formulaire a été envoyé"}
          </p>
          <button 
            className="btn btn-secondary" 
            onClick={this.resetForm}
            aria-label="Retourner au formulaire pour soumettre une nouvelle demande"
          >
            Retour au formulaire
          </button>
        </section>
      );
    } else if (submitted && error && !loading) {
      return (
        <section 
          className="form-container submitted error"
          role="region"
          aria-label="Erreur du formulaire"
          aria-live="polite"
        >
          <h2 className="visually-hidden">Erreur</h2>
          <div role="alert" aria-live="assertive">
            <p>Erreur lors de l'envoi du formulaire</p>
          </div>
          <button 
            className="btn btn-secondary" 
            onClick={this.resetForm}
            aria-label="Retourner au formulaire pour corriger et réessayer"
          >
            Retour au formulaire
          </button>
        </section>
      );
    }

    const formTitle = attrs.title || 'Formulaire personnalisé';
    
    return (
      <section 
        className={`form-container ${loading ? "is-loading" : ""}`}
        role="region"
        aria-label={`Formulaire : ${formTitle}`}
        aria-labelledby="custom-form-heading"
      >
        <h2 id="custom-form-heading" className="visually-hidden">
          {formTitle}
        </h2>
        
        {loading && (
          <div 
            className="loading" 
            role="status" 
            aria-live="polite"
            aria-label="Envoi du formulaire en cours..."
          />
        )}
        
        <AvForm
          onValidSubmit={this.validSubmit}
          onInvalidSubmit={this.invalidSubmit}
          role="form"
          aria-label={formTitle}
        >
          <Row>
            {attrs.wordpress_fields.map(
              f =>
                f.type in switchField &&
                switchField[f.type]({
                  key: f.gravityId,
                  field: f,
                  size: switchSize[f.size]
                })
            )}
          </Row>

          <Row>
            <FormGroup className="captcha-container col-12 col-sm-6">
              <fieldset>
                <legend id="captcha-legend">Veuillez cocher la case ci-dessous *</legend>
                <div role="group" aria-labelledby="captcha-legend">
                  <ReCAPTCHA
                    sitekey={Config_local.recaptchaKey}
                    onChange={this.onCaptchaChange}
                    type="image"
                    aria-label="Vérification de sécurité reCAPTCHA"
                  />
                  <AvGroup className={`textfield col-12 col-sm-6 textfieldsp`}>
                    <AvInput 
                      name="input_100" 
                      id="recaptchValue" 
                      required="true" 
                      type="text" 
                      value={valueCaptcha}
                      aria-label="Valeur de vérification reCAPTCHA"
                    />
                  </AvGroup>
                </div>
              </fieldset>
            </FormGroup>
            <FormGroup className="col-12 col-sm-6 mt-5 mt-md-0 d-flex flex-column justify-content-end">
              <div className="text-center text-sm-right">
                <Button
                  color="primary"
                  className={`submit-button btn btn-primary px-4`}
                  disabled={loading}
                  aria-label={loading ? "Envoi en cours..." : `Soumettre le formulaire ${formTitle}`}
                  aria-busy={loading}
                >
                  {attrs.button.text ? attrs.button.text : "Envoyer"}
                </Button>
              </div>
            </FormGroup>
          </Row>
        </AvForm>
      </section>
    );
  }
}

export default CustomForm;
